module.exports = __webpack_public_path__ + "img/ep-login.d7ff191d.svg";